import { BookOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { CarsSlice } from '@hefe/store';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../store/store';
import CRUDComponent from '../../../crud/components/crud/crud.component';
import AddEditCarForm from '../../forms/add-edit-car/add-edit-car.form';

export default function CarsPage() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const cars = useSelector(CarsSlice.carsSelector);

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = () => {
    setLoading(true);

    dispatch(
      CarsSlice.fetchCars({
        cacheDuration: 5 * 60 * 1000,
      })
    )
      .unwrap()
      .finally(() => setLoading(false));
  };

  return (
    <CRUDComponent
      table={{
        name: 'cars',
        rowKey: 'id',
        loading: loading,
        columns: [
          {
            key: 'licence_plate',
            title: t('cars.licence_plate'),
            dataIndex: 'licence_plate',
            showFilter: true,
            sortType: 'string',
            default: true,
          },
          {
            key: 'manufacturer',
            title: t('manufacturer'),
            dataIndex: 'manufacturer',
            showFilter: true,
            sortType: 'string',
            default: true,
          },
          {
            key: 'model',
            title: t('model'),
            dataIndex: 'model',
            showFilter: true,
            sortType: 'string',
            default: true,
          },
        ],
        dataSource: cars,
        addForm: {
          formId: 'add-edit-car-form-new',
          title: t('cars.create'),
          component: <AddEditCarForm />,
        },
        toolbarItems: [
          <Button
            icon={<BookOutlined />}
            onClick={() => navigate('/admin/cars/reservations')}
          />,
        ],
      }}
      updateComponent={{
        formId: 'add-edit-car-form',
        component: AddEditCarForm,
        propKey: 'car',
        title: t('cars.edit'),
      }}
      delete={{
        action: CarsSlice.deleteCar,
        multiDelete: false,
      }}
    />
  );
}
